//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class Client {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "/api";
    }

    /**
     * Retrieves all available countries from the Search API value list endpoint.
     * @param language (optional) Translation language for the country title. Accepted values: `EN` (default) or `DE`.
     * @return Returns the full list of countries from the value list.
     */
    countries(language: string | undefined): Observable<CountryValueListResponseModelListBaseResultResponseModel> {
        let url_ = this.baseUrl + "/countries?";
        if (language === null)
            throw new globalThis.Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryValueListResponseModelListBaseResultResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryValueListResponseModelListBaseResultResponseModel>;
        }));
    }

    protected processCountries(response: HttpResponseBase): Observable<CountryValueListResponseModelListBaseResultResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CountryValueListResponseModelListBaseResultResponseModel;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Invalid language parameter. Accepted values are EN or DE.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result502: any = null;
            result502 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("The upstream SIBaseX Search API is unavailable or returned an error.", status, _responseText, _headers, result502);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the IBase dropdown values for Classification, Status Object and Unique Identifier
    Type, grouped by property. Results are served from cache when available.
     * @param language (optional) Translation language for the labels. Accepted values: `EN` (default) or `DE`.
     * @return Returns the IBase dropdown values grouped by property.
     */
    ibase(language: string | undefined): Observable<IBaseDropdownResponseModelBaseResultResponseModel> {
        let url_ = this.baseUrl + "/dropdowns/ibase?";
        if (language === null)
            throw new globalThis.Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIbase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIbase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IBaseDropdownResponseModelBaseResultResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IBaseDropdownResponseModelBaseResultResponseModel>;
        }));
    }

    protected processIbase(response: HttpResponseBase): Observable<IBaseDropdownResponseModelBaseResultResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IBaseDropdownResponseModelBaseResultResponseModel;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Invalid language parameter. Accepted values are EN or DE.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result502: any = null;
            result502 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("The upstream SIBaseX Search API is unavailable or returned an error.", status, _responseText, _headers, result502);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the Facility dropdown values for Status Object, grouped by property. Results are
    served from cache when available.
     * @param language (optional) Translation language for the labels. Accepted values: `EN` (default) or `DE`.
     * @return Returns the Facility dropdown values grouped by property.
     */
    facility(language: string | undefined): Observable<FacilityDropdownResponseModelBaseResultResponseModel> {
        let url_ = this.baseUrl + "/dropdowns/facility?";
        if (language === null)
            throw new globalThis.Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFacility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FacilityDropdownResponseModelBaseResultResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FacilityDropdownResponseModelBaseResultResponseModel>;
        }));
    }

    protected processFacility(response: HttpResponseBase): Observable<FacilityDropdownResponseModelBaseResultResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FacilityDropdownResponseModelBaseResultResponseModel;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Invalid language parameter. Accepted values are EN or DE.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result502: any = null;
            result502 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("The upstream SIBaseX Search API is unavailable or returned an error.", status, _responseText, _headers, result502);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the FIRC dropdown values for Status Object, grouped by property. Results are
    served from cache when available.
     * @param language (optional) Translation language for the labels. Accepted values: `EN` (default) or `DE`.
     * @return Returns the FIRC dropdown values grouped by property.
     */
    firc(language: string | undefined): Observable<FircDropdownResponseModelBaseResultResponseModel> {
        let url_ = this.baseUrl + "/dropdowns/firc?";
        if (language === null)
            throw new globalThis.Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFirc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFirc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FircDropdownResponseModelBaseResultResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FircDropdownResponseModelBaseResultResponseModel>;
        }));
    }

    protected processFirc(response: HttpResponseBase): Observable<FircDropdownResponseModelBaseResultResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FircDropdownResponseModelBaseResultResponseModel;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Invalid language parameter. Accepted values are EN or DE.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result502: any = null;
            result502 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("The upstream SIBaseX Search API is unavailable or returned an error.", status, _responseText, _headers, result502);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Ingests a gIB structure consisting of Trusted Components, Commercial Links, and FIRCs.
     * @param body (optional) The gIB structure to ingest. Must contain at least one Trusted Component, Commercial Link, or FIRC.
     * @return The gIB structure was submitted for ingestion; returns the ingestion id.
     */
    gibDataIngestions(body: GibDataIngestionRequestModel | undefined): Observable<GibDataIngestionResponseModelBaseResultResponseModel> {
        let url_ = this.baseUrl + "/gib-data-ingestions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGibDataIngestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGibDataIngestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GibDataIngestionResponseModelBaseResultResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GibDataIngestionResponseModelBaseResultResponseModel>;
        }));
    }

    protected processGibDataIngestions(response: HttpResponseBase): Observable<GibDataIngestionResponseModelBaseResultResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GibDataIngestionResponseModelBaseResultResponseModel;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("The request body is missing or contains no Trusted Components, Commercial Links, or FIRCs.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("The authenticated user is not registered in the system or does not hold an active `taba_user` role.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Resource not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("An unexpected internal server error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result502: any = null;
            result502 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("The upstream Ingest API is unavailable or returned an error.", status, _responseText, _headers, result502);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the Technical Asset hierarchy for the given IBase ID, together with its embedded
    Components/SubComponents and any linked Commercial Assets, Service Locations, End Customers
    and Facilities.
     * @param ibaseId The IBase identifier to search for.
     * @return Returns the Technical Asset search result for the given IBase ID.
     */
    technicalAsset(ibaseId: number): Observable<TechnicalAssetSearchResultResponseModelBaseResultResponseModel> {
        let url_ = this.baseUrl + "/ibases/technical-asset/{ibaseId}";
        if (ibaseId === undefined || ibaseId === null)
            throw new globalThis.Error("The parameter 'ibaseId' must be defined.");
        url_ = url_.replace("{ibaseId}", encodeURIComponent("" + ibaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTechnicalAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTechnicalAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TechnicalAssetSearchResultResponseModelBaseResultResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TechnicalAssetSearchResultResponseModelBaseResultResponseModel>;
        }));
    }

    protected processTechnicalAsset(response: HttpResponseBase): Observable<TechnicalAssetSearchResultResponseModelBaseResultResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TechnicalAssetSearchResultResponseModelBaseResultResponseModel;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("The provided ibaseId is invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of proposals for a given iBase ID.
     * @param iBaseId (optional) The ID of the iBase for which to retrieve proposals.
     * @return OK
     */
    proposals(iBaseId: number | undefined): Observable<ProposalListResponseModelBaseResultResponseModel> {
        let url_ = this.baseUrl + "/proposals?";
        if (iBaseId === null)
            throw new globalThis.Error("The parameter 'iBaseId' cannot be null.");
        else if (iBaseId !== undefined)
            url_ += "iBaseId=" + encodeURIComponent("" + iBaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProposals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProposals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProposalListResponseModelBaseResultResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProposalListResponseModelBaseResultResponseModel>;
        }));
    }

    protected processProposals(response: HttpResponseBase): Observable<ProposalListResponseModelBaseResultResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProposalListResponseModelBaseResultResponseModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the components for a given proposal by its ID.
     * @param id The unique identifier of the proposal.
     * @return Returns the proposal detail and component list.
     */
    components(id: number): Observable<ProposalDetailResponseModelBaseResultResponseModel> {
        let url_ = this.baseUrl + "/proposals/{id}/components";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComponents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComponents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProposalDetailResponseModelBaseResultResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProposalDetailResponseModelBaseResultResponseModel>;
        }));
    }

    protected processComponents(response: HttpResponseBase): Observable<ProposalDetailResponseModelBaseResultResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProposalDetailResponseModelBaseResultResponseModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("No proposal found with the given ID.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all available application roles.
     * @return Returns the full list of available roles.
     */
    rolesGET(): Observable<RoleResponseModelListBaseResultResponseModel> {
        let url_ = this.baseUrl + "/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRolesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRolesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleResponseModelListBaseResultResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleResponseModelListBaseResultResponseModel>;
        }));
    }

    protected processRolesGET(response: HttpResponseBase): Observable<RoleResponseModelListBaseResultResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleResponseModelListBaseResultResponseModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("No roles exist in the system.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Searches for Siemens employees in the SCD directory by GID prefix.
     * @param gid (optional) The GID (Global ID) to search for. Must be at least 3 characters long.
    A partial GID may be supplied — the SCD API will perform a prefix/contains match.
     * @return Returns the list of matching Siemens employees.
     */
    siemensEmployees(gid: string | undefined): Observable<ScdPeopleApiContentResponseModelBaseResultResponseModel> {
        let url_ = this.baseUrl + "/siemens-employees?";
        if (gid === null)
            throw new globalThis.Error("The parameter 'gid' cannot be null.");
        else if (gid !== undefined)
            url_ += "gid=" + encodeURIComponent("" + gid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSiemensEmployees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSiemensEmployees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScdPeopleApiContentResponseModelBaseResultResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScdPeopleApiContentResponseModelBaseResultResponseModel>;
        }));
    }

    protected processSiemensEmployees(response: HttpResponseBase): Observable<ScdPeopleApiContentResponseModelBaseResultResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScdPeopleApiContentResponseModelBaseResultResponseModel;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("The supplied GID is null, empty or shorter than 3 characters.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result502: any = null;
            result502 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("The upstream Siemens SCD API is unavailable or returned an error.", status, _responseText, _headers, result502);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Searches for users and their role assignments using optional filters and pagination.
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param gid (optional) 
     * @param department (optional) 
     * @param email (optional) 
     * @param country (optional) 
     * @param isProtected (optional) 
     * @param roles (optional) 
     * @param offset (optional) 
     * @param elements (optional) 
     * @return Returns the paginated list of matching users.
     */
    usersGET(firstName: string | undefined, lastName: string | undefined, gid: string | undefined, department: string | undefined, email: string | undefined, country: string | undefined, isProtected: boolean | undefined, roles: RoleType[] | undefined, offset: number | undefined, elements: number | undefined): Observable<UserManagementResponseModelBasePaginatedResultResponseModel> {
        let url_ = this.baseUrl + "/users?";
        if (firstName === null)
            throw new globalThis.Error("The parameter 'firstName' cannot be null.");
        else if (firstName !== undefined)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName === null)
            throw new globalThis.Error("The parameter 'lastName' cannot be null.");
        else if (lastName !== undefined)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (gid === null)
            throw new globalThis.Error("The parameter 'gid' cannot be null.");
        else if (gid !== undefined)
            url_ += "Gid=" + encodeURIComponent("" + gid) + "&";
        if (department === null)
            throw new globalThis.Error("The parameter 'department' cannot be null.");
        else if (department !== undefined)
            url_ += "Department=" + encodeURIComponent("" + department) + "&";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (country === null)
            throw new globalThis.Error("The parameter 'country' cannot be null.");
        else if (country !== undefined)
            url_ += "Country=" + encodeURIComponent("" + country) + "&";
        if (isProtected === null)
            throw new globalThis.Error("The parameter 'isProtected' cannot be null.");
        else if (isProtected !== undefined)
            url_ += "IsProtected=" + encodeURIComponent("" + isProtected) + "&";
        if (roles === null)
            throw new globalThis.Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "Roles=" + encodeURIComponent("" + item) + "&"; });
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (elements === null)
            throw new globalThis.Error("The parameter 'elements' cannot be null.");
        else if (elements !== undefined)
            url_ += "Elements=" + encodeURIComponent("" + elements) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsersGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsersGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserManagementResponseModelBasePaginatedResultResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserManagementResponseModelBasePaginatedResultResponseModel>;
        }));
    }

    protected processUsersGET(response: HttpResponseBase): Observable<UserManagementResponseModelBasePaginatedResultResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserManagementResponseModelBasePaginatedResultResponseModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller does not have the `user_manager` role.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new user record in the system and assigns the specified roles.
     * @param body (optional) Body containing the new user's `Gid` and an initial list of `Roles` to assign.
    The `taba_user` role is mandatory and must be included in the list.
     * @return Returns the newly created user and their assigned roles.
     */
    usersPOST(body: UserManagementCreateRequestModel | undefined): Observable<UserManagementResponseModelBaseResultResponseModel> {
        let url_ = this.baseUrl + "/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsersPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsersPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserManagementResponseModelBaseResultResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserManagementResponseModelBaseResultResponseModel>;
        }));
    }

    protected processUsersPOST(response: HttpResponseBase): Observable<UserManagementResponseModelBaseResultResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserManagementResponseModelBaseResultResponseModel;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("The `taba_user` role is missing from the roles list.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller does not have the `user_manager` role.", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("A user with the supplied GID already exists.", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the profile and role assignments of the currently authenticated user.
     * @return Returns the authenticated user's profile and roles.
     */
    me(): Observable<UserManagementResponseModelBaseResultResponseModel> {
        let url_ = this.baseUrl + "/users/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserManagementResponseModelBaseResultResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserManagementResponseModelBaseResultResponseModel>;
        }));
    }

    protected processMe(response: HttpResponseBase): Observable<UserManagementResponseModelBaseResultResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserManagementResponseModelBaseResultResponseModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller does not have the `taba_user` role.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("The GID claim could not be resolved, or no matching user record was found.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a specific user's profile and current roles by their GID.
     * @param gid The GID (Global ID) that uniquely identifies the user.
     * @return Returns the user's profile and roles.
     */
    getUserByGid(gid: string): Observable<UserManagementResponseModelBaseResultResponseModel> {
        let url_ = this.baseUrl + "/users/{gid}";
        if (gid === undefined || gid === null)
            throw new globalThis.Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserByGid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserByGid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserManagementResponseModelBaseResultResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserManagementResponseModelBaseResultResponseModel>;
        }));
    }

    protected processGetUserByGid(response: HttpResponseBase): Observable<UserManagementResponseModelBaseResultResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserManagementResponseModelBaseResultResponseModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller does not have the `user_manager` role.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("No user was found for the supplied GID.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the paginated role-change history for a specific user.
     * @param gid The GID that uniquely identifies the user whose history is requested.
     * @param offset Number of history records to skip (zero-based offset). Defaults to `0`.
     * @param elements Maximum number of history records to return. Defaults to `10`.
     * @return Returns the user's role-change history.
     */
    history(gid: string, offset: number, elements: number): Observable<UserManagementHistoryResponseModelBaseResultResponseModel> {
        let url_ = this.baseUrl + "/users/{gid}/roles/history?";
        if (gid === undefined || gid === null)
            throw new globalThis.Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        if (offset === undefined || offset === null)
            throw new globalThis.Error("The parameter 'offset' must be defined and cannot be null.");
        else
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (elements === undefined || elements === null)
            throw new globalThis.Error("The parameter 'elements' must be defined and cannot be null.");
        else
            url_ += "elements=" + encodeURIComponent("" + elements) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserManagementHistoryResponseModelBaseResultResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserManagementHistoryResponseModelBaseResultResponseModel>;
        }));
    }

    protected processHistory(response: HttpResponseBase): Observable<UserManagementHistoryResponseModelBaseResultResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserManagementHistoryResponseModelBaseResultResponseModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller does not have the `user_manager` role.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("No history was found for the supplied GID.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Replaces the role list of an existing user identified by their GID.
     * @param gid The GID (Global ID) that uniquely identifies the user.
     * @param body (optional) Body containing the new set of `Roles` to assign. The supplied list completely replaces the user's current roles.
     * @return Returns the user with their updated roles.
     */
    rolesPUT(gid: string, body: UserManagementUpdateRolesBodyModel | undefined): Observable<UserManagementResponseModelBaseResultResponseModel> {
        let url_ = this.baseUrl + "/users/{gid}/roles";
        if (gid === undefined || gid === null)
            throw new globalThis.Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRolesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRolesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserManagementResponseModelBaseResultResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserManagementResponseModelBaseResultResponseModel>;
        }));
    }

    protected processRolesPUT(response: HttpResponseBase): Observable<UserManagementResponseModelBaseResultResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserManagementResponseModelBaseResultResponseModel;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller does not have the `user_manager` role.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("No user was found for the supplied GID.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exports the complete list of users and their assigned roles as an Excel (`.xlsx`) file.
     * @return Returns the Excel file as a binary stream.
     */
    export(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/users/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller does not have the `user_manager` role.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("No user data available to export.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Searches for Siemens employees in the SCD directory by GIDs
    and creates new users in the local database if they don't exist already.
     * @param body (optional) The list of GIDs (Global IDs) to search for. Each GID must be at least 3 characters long.
     * @return Returns a list of results indicating success or failure for each GID.
     */
    batch(body: string[] | undefined): Observable<MultipleUserRoleResponseModelListBaseResultResponseModel> {
        let url_ = this.baseUrl + "/users/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MultipleUserRoleResponseModelListBaseResultResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MultipleUserRoleResponseModelListBaseResultResponseModel>;
        }));
    }

    protected processBatch(response: HttpResponseBase): Observable<MultipleUserRoleResponseModelListBaseResultResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MultipleUserRoleResponseModelListBaseResultResponseModel;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("One or more supplied GIDs are null, empty or shorter than 3 characters.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller does not have the `user_manager` role.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes all role assignments from a list of users identified by their GIDs.
     * @param body (optional) A list of GIDs (Global IDs) identifying the users whose roles should be removed.
    Each GID must be at least 3 characters long.
     * @return Returns a list of results for each GID, indicating success or failure with descriptive messages.
     */
    removeAllRoles(body: string[] | undefined): Observable<MultipleUserRoleResponseModelListBaseResultResponseModel> {
        let url_ = this.baseUrl + "/users/remove-all-roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAllRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAllRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MultipleUserRoleResponseModelListBaseResultResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MultipleUserRoleResponseModelListBaseResultResponseModel>;
        }));
    }

    protected processRemoveAllRoles(response: HttpResponseBase): Observable<MultipleUserRoleResponseModelListBaseResultResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MultipleUserRoleResponseModelListBaseResultResponseModel;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("One or more GIDs are null, empty, or shorter than 3 characters.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Caller does not have the `user_manager` role.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export enum ActorType {
    User = "User",
    Application = "Application",
}

export interface CommercialLinkResponseModel {
    id: number | null;
    name: string | null;
    uniqueIdentifier: string | null;
    uniqueIdentifierType: string | null;
    statusObject: string | null;
    subComponentIds: number[] | null;
}

export interface CountryValueListResponseModel {
    code: string | null;
    continent: string | null;
    countryCharacteristic: string | null;
    countryGroup: number | null;
    language: string | null;
    leadCountry: string | null;
    statusObject: string | null;
    currency: string | null;
    timezone: string | null;
    title: string | null;
}

export interface CountryValueListResponseModelListBaseResultResponseModel {
    data: CountryValueListResponseModel[] | null;
    links: LinksResponseModel;
}

export interface ErrorExceptionResponseModel {
    statusCode: number;
    code: string | null;
    message: string | null;
    details: string | null;
}

/** Facility dropdown/lookup values grouped by property, translated to a single requested language. Each dictionary maps the SIBaseX `ALIAS` value to its translated label. */
export interface FacilityDropdownResponseModel {
    statusObject: { [key: string]: string; } | null;
}

export interface FacilityDropdownResponseModelBaseResultResponseModel {
    data: FacilityDropdownResponseModel;
    links: LinksResponseModel;
}

export interface FacilityResponseModel {
    id: number | null;
    name: string | null;
    zipCode: string | null;
    cityInt: string | null;
    streetInt: string | null;
    country: string | null;
    statusObject: string | null;
    ifa: string | null;
}

/** FIRC dropdown/lookup values grouped by property, translated to a single requested language. Each dictionary maps the SIBaseX `ALIAS` value to its translated label. */
export interface FircDropdownResponseModel {
    statusObject: { [key: string]: string; } | null;
}

export interface FircDropdownResponseModelBaseResultResponseModel {
    data: FircDropdownResponseModel;
    links: LinksResponseModel;
}

export interface FircResponseModel {
    country: string | null;
    refIdIBase: number[] | null;
    refIdSite: number | null;
    role: string | null;
    statusObject: string | null;
}

/** Request representation of a Commercial Link iBase to be ingested. Maps to an upstream `Ibase` record with `AssetCollectionConnector._RefID_ChildIBase` carrying the sub-component references. */
export interface GibCommercialLinkRequestModel {
    /** The iBase id (gIB `_ID`). */
    id: number | null;
    /** References to the child iBase ids that are sub-components of this Commercial Link (gIB `AssetCollectionConnector._RefID_ChildIBase`). */
    subComponentIds: number[] | null;
}

/** Request payload for ingesting a gIB structure. Contains Trusted Components, Commercial Links, and FIRCs to be forwarded to the Ingest API. Other gIB objects (Attachments, Contact Persons, etc.) are not supported. */
export interface GibDataIngestionRequestModel {
    /** The gIB `_ID` of the root iBase. Used for server-side validation only (existence check
and `TechnicalAsset` classification guard) and is NOT forwarded to the upstream Ingest API payload. */
    iBaseId: number;
    /** The trusted Component iBases to ingest. */
    trustedComponents: GibTrustedComponentRequestModel[] | null;
    /** The Commercial Link iBases to ingest. */
    commercialLinks: GibCommercialLinkRequestModel[] | null;
    /** The FIRCs (Facility-IBase-Role-Connectors) to ingest. Used exclusively for new Components. */
    fircs: GibFircRequestModel[] | null;
}

/** Response payload returned after a gIB structure has been submitted for ingestion. */
export interface GibDataIngestionResponseModel {
    /** The generated ingestion id returned by the upstream Ingest API. */
    ingestId: string | null;
}

export interface GibDataIngestionResponseModelBaseResultResponseModel {
    data: GibDataIngestionResponseModel;
    links: LinksResponseModel;
}

/** Request representation of a gIB FIRC (Facility-IBase-Role-Connector) to be ingested. Used exclusively for new Components not yet known in SiBase X. */
export interface GibFircRequestModel {
    /** The FIRC message id (gIB `_MsgID`). */
    msgId: string | null;
    /** Reference to the related iBase message id (gIB `_RefMsgID_IBase`). */
    refMsgIdIBase: string | null;
    /** Reference to the related site id (gIB `_RefID_Site`). */
    refIdSite: number | null;
    /** The role (gIB `_Role`). */
    role: string | null;
}

/** Request representation of a trusted Component iBase to be ingested. Maps to an upstream `Ibase` record with `_Classification` identifying it as a Component or SubComponent. */
export interface GibTrustedComponentRequestModel {
    /** The iBase id (gIB `_ID`). Required for Components already known in SiBase X. */
    id: number | null;
    /** The iBase message id (gIB `_MsgID`). Used for Components not yet known in SiBase X. */
    msgId: string | null;
    /** Reference to the parent iBase id (gIB `_RefID_ParentIBase`). */
    refIdParentIBase: number | null;
    /** The iBase classification (gIB `_Classification`). */
    classification: string | null;
    /** The product number (gIB `ProductNumber`). */
    productNumber: string | null;
    /** The serial number (gIB `SerialNumber`). */
    serialNumber: string | null;
    /** The quantity (gIB `Quantity`). */
    quantity: number | null;
}

/** IBase dropdown/lookup values grouped by property, translated to a single requested language. Each dictionary maps the SIBaseX `ALIAS` value to its translated label. */
export interface IBaseDropdownResponseModel {
    classification: { [key: string]: string; } | null;
    statusObject: { [key: string]: string; } | null;
    uniqueIdentifierType: { [key: string]: string; } | null;
}

export interface IBaseDropdownResponseModelBaseResultResponseModel {
    data: IBaseDropdownResponseModel;
    links: LinksResponseModel;
}

export interface LinksResponseModel {
    self: string | null;
}

export interface MetaResponseModel {
    page: PageResponseModel;
}

/** Represents the result of a user role operation for a single GID. */
export interface MultipleUserRoleResponseModel {
    /** The GID (Global ID) of the user this result pertains to. */
    gid: string | null;
    /** Indicates whether the operation was successful for this user. */
    success: boolean;
    /** A descriptive message explaining the result (e.g., success confirmation or error detail). */
    message: string | null;
}

export interface MultipleUserRoleResponseModelListBaseResultResponseModel {
    data: MultipleUserRoleResponseModel[] | null;
    links: LinksResponseModel;
}

export interface PageResponseModel {
    totalElements: number;
    offset: number;
    elements: number;
}

export interface PaginatedLinksResponseModel {
    self: string | null;
    next: string | null;
    last: string | null;
}

export interface ProposalComponentResponseModel {
    id: number;
    category: string | null;
    date: Date;
}

export interface ProposalDetailComponentResponseModel {
    id: number;
    quantity: number;
    name: string | null;
    productNumber: string | null;
    serialNumber: string | null;
    maxQtd: number;
}

export interface ProposalDetailResponseModel {
    id: number;
    date: Date;
    components: ProposalDetailComponentResponseModel[] | null;
}

export interface ProposalDetailResponseModelBaseResultResponseModel {
    data: ProposalDetailResponseModel;
    links: LinksResponseModel;
}

export interface ProposalListResponseModel {
    components: ProposalComponentResponseModel[] | null;
}

export interface ProposalListResponseModelBaseResultResponseModel {
    data: ProposalListResponseModel;
    links: LinksResponseModel;
}

export interface RoleResponseModel {
    id: number;
    roleType: RoleType;
    description: string | null;
}

export interface RoleResponseModelListBaseResultResponseModel {
    data: RoleResponseModel[] | null;
    links: LinksResponseModel;
}

export enum RoleType {
    Taba_user = "taba_user",
    User_manager = "user_manager",
    Application_manager = "application_manager",
}

export interface ScdEmployeeResponseModel {
    gid: string | null;
    email: string | null;
    givenName: string | null;
    lastName: string | null;
    department: string | null;
    country: string | null;
}

export interface ScdPeopleApiContentResponseModel {
    peoples: ScdEmployeeResponseModel[] | null;
}

export interface ScdPeopleApiContentResponseModelBaseResultResponseModel {
    data: ScdPeopleApiContentResponseModel;
    links: LinksResponseModel;
}

export interface TechnicalAssetResponseModel {
    id: number | null;
    name: string | null;
    uniqueIdentifier: string | null;
    uniqueIdentifierType: string | null;
    mainProductGroup: string | null;
    mainPurposeGroup: string | null;
    statusObject: string | null;
}

export interface TechnicalAssetSearchResultResponseModel {
    technicalAsset: TechnicalAssetResponseModel;
    trustedComponent: TrustedComponentResponseModel[] | null;
    commercialLinks: CommercialLinkResponseModel[] | null;
    serviceLocations: FircResponseModel[] | null;
    endCustomers: FircResponseModel[] | null;
    facilities: FacilityResponseModel[] | null;
    errors: string[] | null;
}

export interface TechnicalAssetSearchResultResponseModelBaseResultResponseModel {
    data: TechnicalAssetSearchResultResponseModel;
    links: LinksResponseModel;
}

export interface TrustedComponentResponseModel {
    id: number | null;
    name: string | null;
    statusObject: string | null;
    productNumber: string | null;
    serialNumber: string | null;
    quantity: number;
    refIdParentIBase: number | null;
}

export enum UserHistoryActionType {
    Added = "Added",
    Removed = "Removed",
}

export interface UserManagementCreateRequestModel {
    gid: string | null;
    roles: RoleType[] | null;
}

export interface UserManagementHistoryRecordResponseModel {
    timeOffset: Date;
    roleType: RoleType;
    userHistoryActionType: UserHistoryActionType;
    modifiedBy: UserManagementUserHistoryResponseModel;
}

export interface UserManagementHistoryResponseModel {
    lastChange: Date | null;
    lastChangeBy: UserManagementUserHistoryResponseModel;
    createdBy: UserManagementUserHistoryResponseModel;
    createdOn: Date;
    history: UserManagementHistoryRecordResponseModel[] | null;
}

export interface UserManagementHistoryResponseModelBaseResultResponseModel {
    data: UserManagementHistoryResponseModel;
    links: LinksResponseModel;
}

export interface UserManagementResponseModel {
    user: UserResponseModel;
    roles: RoleResponseModel[] | null;
}

export interface UserManagementResponseModelBasePaginatedResultResponseModel {
    data: UserManagementResponseModel[] | null;
    links: PaginatedLinksResponseModel;
    meta: MetaResponseModel;
}

export interface UserManagementResponseModelBaseResultResponseModel {
    data: UserManagementResponseModel;
    links: LinksResponseModel;
}

export interface UserManagementUpdateRolesBodyModel {
    roles: RoleType[] | null;
}

export interface UserManagementUserHistoryResponseModel {
    actorType: ActorType;
    firstName: string | null;
    lastName: string | null;
    appName: string | null;
    appId: string | null;
}

export interface UserResponseModel {
    id: number;
    gid: string | null;
    email: string | null;
    firstName: string | null;
    lastName: string | null;
    displayName: string | null;
    country: string | null;
    city: string | null;
    streetAddress: string | null;
    postalCode: string | null;
    department: string | null;
    isProtected: boolean;
    lastLoginDate: Date | null;
    createdAt: Date;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}